$shm_hitalama_codex_map $shm_codex_app
	map_id \
	sessions_page_visible false
	width? 432
	width_px \432px
	Side_resizer $shm_hitalama_resizer_side
		resize_side \left
		width? <=> width?
	Sessions_icon $mol_icon_chat
	chat_tools /
		^
		<= Agent_config $mol_select
			hint \Конфигурация ИИ-агента
			value? <=> agent_config? \
			dictionary <= agent_config_dictionary *
	style *
		^
		width <= width_px
		flexBasis <= width_px
		flexGrow 0
		flexShrink 0
		minWidth \24rem
